import { forwardRef } from 'react';
import { cn } from '../../lib/utils';

interface FormSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  error?: boolean;
  description?: string;
}

const FormSelect = forwardRef<HTMLSelectElement, FormSelectProps>(
  ({ className, error, description, ...props }, ref) => (
    <div>
      <select
        ref={ref}
        className={cn(
          'mt-1 block w-full rounded-xl border bg-white dark:bg-gray-900/50 px-3.5 py-2.5 text-sm shadow-soft transition-all duration-200 ease-smooth',
          error
            ? 'border-red-300 dark:border-red-800 focus:border-red-500 focus:ring-red-500/30'
            : 'border-gray-200 dark:border-gray-700 focus:border-primary-500 focus:ring-primary-500/20 dark:focus:border-primary-400',
          className
        )}
        {...props}
      />
      {description && (
        <p className="mt-1.5 text-sm text-gray-500 dark:text-gray-400">
          {description}
        </p>
      )}
    </div>
  )
);
FormSelect.displayName = 'FormSelect';

export { FormSelect };
